import { Button } from "@material-ui/core";
import React, { ReactElement } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import styled from "styled-components/macro";
import { launchExperience } from "../store/selections/selectionsActions";
import Logo from "./Logo";

const CodeScreenDiv = styled.div`
	margin: 30px;
	width: 100%;
	flex: 1;
	display: flex;
	align-items: center;
	flex-direction: column;
	overflow-x: hidden;
	text-align: center;
`;

const Subtitle = styled.div`
	padding: 30px;
	font-size: 24px;
	line-height: 28px;
	text-align: left;
`;
const LogoSpacer = styled.div`
	height: 50%;
`;
const BackButton = styled(Button)`
	font-size: 24px;
	line-height: 30px;
	border-radius: 3px;
	padding: 15px 110px;
	margin: 10px;
	text-transform: none;
	font-weight: normal;
`;

const Blank = styled.div`
	flex: 1;
`;

const Code = styled.div`
	padding: 30px;
	font-size: 24px;
	font-weight: bold;
	line-height: 28px;
	text-align: center;
	overflow-wrap: anywhere;
`;

function CodeScreen(): ReactElement {
	const dispatch = useDispatch();
	const { code } = useParams<{ code: string }>();

	const onLaunch = () => {
		dispatch(launchExperience(code));
	};

	return (
		<CodeScreenDiv>
			<Logo />
			<LogoSpacer />
			<Subtitle>Welcome back!</Subtitle>
			<Subtitle>Using code:</Subtitle>
			<Code>{code}</Code>
			<Blank />
			<BackButton variant="contained" color="primary" onClick={onLaunch}>
				Launch Experience
			</BackButton>
			<Blank />
		</CodeScreenDiv>
	);
}

export default CodeScreen;
